import React, { useState } from "react";
import styles from "./Inventory.module.scss";
import { ProductsTable } from "./components/ProductsTable/ProductsTable";
import { Header } from "./components/Header/Header";
import { FilterPanel } from "./components/FilterPanel/FilterPanel";
import { useGetFilters } from "../../utils/react-query/queryEcommerce/queries";
import useCompanyStore from "../../Store/supplierCompany/companyData";

const Inventory: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const { companyName } = useCompanyStore();
  const { data: filterOptions } = useGetFilters(companyName || "");

  return (
    <div className={styles.container}>
      <Header
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onFilterToggle={() => setIsFilterOpen(!isFilterOpen)}
        isFilterOpen={isFilterOpen}
      />

      <div className={styles.tableContainer}>
        <ProductsTable searchQuery={searchQuery} />
      </div>

      <FilterPanel
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        options={filterOptions?.filters}
      />
    </div>
  );
};

export default Inventory;
